'use strict';
angular.module("noticeDetailModule", []).
controller("noticeDetailCtrl", ["trsHttpService", "$state", "$scope", "$q", function(trsHttpService, $state, $scope, $q) {
    initStatus();
    initData();
    /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            noticeId: $state.params.noticeid
        };
        $scope.data = {};
        $scope.headPic = '';
    }
    /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
    function initData() {
        headPortrait();
        getNoticeDetail();
    }
    /**
     * [headPortrait description] 获取用户头像
     * @return {[type]} [description]
     */
    function headPortrait() {
        var params = {
            serviceid: 'mlf_extuser',
            methodname: 'getUserHeadPic',
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
        });
    }
    /**
     * [getNoticeDetail description]获取公告详情
     * @return {[type]} [description]
     */
    function getNoticeDetail() {
        let defer = $q.defer();
        let params = {
            serviceid: 'notice',
            method: 'noticeDetial',
            noticeid: $scope.status.noticeId
        }
        trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then((data) => {
            $scope.data.noticeInfo = {
                typename: data.data.typename,
                typeid: data.data.typeid,
                title: data.data.title,
                titlecolor: data.data.titlecolor,
                content: data.data.content,
                appendixinfo: data.data.appendixs.map((_item) => {
                    return {
                        FileSize: _item.filesize,
                        FileDesc: _item.filedesc,
                        FileName: _item.filename,
                    }
                }),
            }
            localStorage.setItem('gotoNoticeDetail', 'true');
            defer.resolve();
        });
        return defer.promise;
    }
    /**
     * [downloadFile description] 文件下载
     * @param  {[type]} file [description] 文件
     * @return {[type]}      [description]
     */
    $scope.downloadFile = function(file) {
        window.open("/message/notice/downFile?filename=" + file.FileName);
    }
}]);